/**
 * @desc downloadOrder
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.AllOrdersRequest, options?: any) {
  return updateResponse(
    http(URL + `/test/downloadOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
